import request from '../utils/request';

// 原密码验证;
export function verifyOld(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontExhibitor/modifyPwd/oldPwd',
    method: 'post',
    data: formData,
  });
}
// 修改密码;
export function modifyPassword(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontExhibitor/modifyPwd/action',
    method: 'post',
    data: formData,
  });
}
